import React from 'react';
import cx from 'classnames';
import Button from './Button';

export default function PrimaryButton({ big, full, disabled, loading, onClick, children, ...rest }) {
  return (
    <div
      className={cx({
        'btn--primary-wrap': true,
        'btn--primary-wrap--big': big,
        'btn--primary-wrap--full': full,
        'btn--primary-wrap--disabled': disabled,
        'btn--primary-wrap--loading': loading,
      })}
      onClick={disabled ? null : onClick}
    >
      <Button big={big} full={full} filled disabled={disabled} loading={loading} {...rest}>
        {children}
      </Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/button/PrimaryButton.js